<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    tabindex="-1"
    ref="modalMap"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-width"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div class="card_title_1">
              <h5 style="font-weight: bold">{{ titleNetwork }}</h5>
            </div>
            <!-- <div class="card_title_2">Last Update: {{ lastUpdate }}</div> -->
          </div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div style="display: flex; justify-content: space-between">
            <div>
              {{ dataCard[0] !== undefined ? dataCard[0].instanceName : "" }}
              <span style="font-weight: bold">
                Electricity Sold YTD
                {{
                  dataCard[0] !== undefined
                    ? dataCard[0].gwhValue !== null
                      ? dataCard[0].gwhValue
                      : 0
                    : 0
                }}
                GWh</span
              >
            </div>
            <!-- <div>
              PIC:
              <span style="font-weight: bold"
                >Reza Purnama <vue-feather type="send"></vue-feather
              ></span>
            </div> -->
          </div>
          <div class="row">
            <div v-for="(item, id) in dataCard" :key="id" class="col-md-4">
              <div
                class="card card_white flex-fill"
                :class="selected ? 'selected' : ''"
                style="margin-bottom: 8px; cursor: pointer"
                v-bind:style="height != null ? 'height: ' + height + 'px;' : ''"
              >
                <div class="sub_title_2">
                  <span>Archievement of Revenue target</span>
                </div>
                <div
                  style="justify-content: space-between"
                  class="d-flex align-items-center"
                >
                  <div class="data_text">
                    {{ item.achievementValue }} {{ item.unit }}
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(item, id) in dataCard" :key="id" class="col-md-4">
              <div
                class="card card_white flex-fill"
                :class="selected ? 'selected' : ''"
                style="margin-bottom: 8px; cursor: pointer"
                v-bind:style="height != null ? 'height: ' + height + 'px;' : ''"
              >
                <div class="sub_title_2">
                  <span>Data Revenue</span>
                </div>
                <div
                  style="justify-content: space-between"
                  class="d-flex align-items-center"
                >
                  <div class="data_text">{{ item.totalRevenue }} Bn</div>
                  <div style="flex: 1; text-align: right" class="d-flex ms-2">
                    <div
                      v-if="item.achievement !== null"
                      class="d-inline-flex align-items-center me-2"
                      :class="
                        item.achievementStatus === 'DOWN'
                          ? 'badge_red'
                          : 'badge_green'
                      "
                    >
                      <IconSvg
                        :color="
                          item.achievementStatus === 'DOWN' ? 'red' : 'green'
                        "
                        :type="
                          item.achievementStatus === 'DOWN'
                            ? 'arrow_down'
                            : 'arrow_up'
                        "
                      />
                      <div
                        class="data_detil"
                        :style="
                          item.achievementStatus === 'DOWN'
                            ? 'color: red'
                            : 'color:green'
                        "
                      >
                        {{ item.achievement }}
                      </div>
                    </div>
                    <div
                      v-if="item.trendStatus !== null"
                      class="d-inline-flex align-items-center"
                      :class="
                        item.trendStatus === 'DOWN'
                          ? 'badge_red'
                          : 'badge_green'
                      "
                    >
                      <IconSvg
                        :color="item.trendStatus === 'DOWN' ? 'red' : 'green'"
                        :type="
                          item.trendStatus === 'DOWN'
                            ? 'chart_down'
                            : 'chart_up'
                        "
                      />
                      <div
                        class="data_detil"
                        :style="
                          item.trendStatus === 'DOWN'
                            ? 'color: red'
                            : 'color:green'
                        "
                      >
                        {{ item.trend }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div>
              <h5>SALES DETAILS</h5>
              <div class="card-header-right">
                <div class="list-mobile">
                  <button
                    @click="idr"
                    class="border-period-left btn-small btn btn-square btn-disable"
                    :class="{ 'btn-info color-active': activeIdr }"
                    type="button"
                    title="btn btn-square btn-primary"
                  >
                    IDR
                  </button>
                  <button
                    @click="gwh"
                    :class="{ 'btn-info color-active': isActiveIdr }"
                    class="border-period-right btn-small btn btn-square btn-disable m-r-10"
                    type="button"
                    title="btn btn-square btn-primary"
                  >
                    GWh
                  </button>
                  <button
                    @click="monthly"
                    class="border-period-left btn btn-small btn-square btn-disable"
                    :class="{ 'btn-info color-active': activeMonth }"
                    type="button"
                    title="btn btn-square btn-disable btn-primary"
                  >
                    Monthly
                  </button>
                  <button
                    @click="year"
                    :class="{ 'btn-info color-active': isActiveMonth }"
                    class="border-period-right btn btn-small btn-square btn-disable m-r-10"
                    type="button"
                    title="btn btn-square btn-primary"
                  >
                    Yearly
                  </button>
                </div>
              </div>
            </div>
            <apexchart
              height="400"
              width="100%"
              type="line"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import DistributionService from "@/services/distribution/distribution";
const apiDistribution = DistributionService.build();
export default {
  components: {
    IconSvg,
  },
  props: ["showModal", "dataNetworkDetail", "titleNetwork"],
  data() {
    return {
      activeIdr: true,
      activeMonth: true,
      dataCard: [],
      isActiveIdr: false,
      isActiveMonth: false,
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          toolbar: {
            show: false, // Hide toolbar
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%", // Adjust column width
          },
        },
        colors: [
          function ({ value, seriesIndex, dataPointIndex, w }) {
            const data = w.config.series;
            const item = data.filter((item) => item.type === "line");
            if (
              (data[1] && dataPointIndex == 10) ||
              (data[1] && dataPointIndex == 11)
            ) {
              return "#868e96";
            } else {
              return "#8099D9";
            }
          },
        ],
        xaxis: {
          categories: [],
        },
        yaxis: [
          // {
          //   title: {
          //     text: "Forecast",
          //   },
          // },
          // {
          //   opposite: true,
          //   title: {
          //     text: "Actual",
          //   },
          // },
        ],
        legend: {
          show: true,
          position: "top",
          labels: {
            // colors: ["#ff5151", "#8099D9", "#333"], // Define label colors
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: "#ff5151",
            radius: 12,
          },
        },
        stroke: {
          width: [4, 0, 0],
          dashArray: [4, 0, 0],
        },
        markers: {
          // size: 6, // Set the size of the markers
          // colors: ["#ff5151"], // Set the color of the markers
          // strokeWidth: 1, // Set the width of the markers' border
        },
      },
      modal: null,
      series: [],
      lastUpdate: "",
    };
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modalMap);
  },

  methods: {
    idr() {
      this.activeIdr = true;
      this.isActiveIdr = false;
      this.getDataChart(this.dataCard);
    },
    gwh() {
      this.activeIdr = false;
      this.isActiveIdr = true;
      this.getDataChart(this.dataCard);
    },
    monthly() {
      this.activeMonth = true;
      this.isActiveMonth = false;
      this.getDataChart(this.dataCard);
    },
    year() {
      this.activeMonth = false;
      this.isActiveMonth = true;
      this.getDataChart(this.dataCard);
    },
    // async getDataChart() {
    //   const datas = [
    //     {
    //       color: "#ff5151",
    //       name: "Target",
    //       type: "line",
    //       data: [4, 5, 6, 7, 8, 9],
    //     },
    //     {
    //       // color:"#8099D9",
    //       name: "Actual",
    //       type: "column",
    //       data: [3, 4, 5, 6, 7, 8],
    //     },
    //   ];
    //   this.series = datas;
    // },
    async getDataCard() {
      let param = Object.assign({
        cityId: this.dataNetworkDetail.cityId !== undefined ? this.dataNetworkDetail.cityId : 'All',
      });
      const res = await apiDistribution.getDataCardNetwork(param);
      this.lastUpdate = res.data.lastUpdate;
      if (res.data.status === 200 && res.data.data.length > 0) {
        this.dataCard = res.data.data;
        this.getDataChart(this.dataCard);
      }
    },
    async getDataChart(chart) {
      let param = Object.assign({
        instanceId: chart[0].instanceId,
        valueType: this.isActiveIdr ? "gwh" : "idr",
        periodType: this.isActiveMonth ? "yearly" : "monthly",
      });
      const res = await apiDistribution.getDataChartNetwork(param);
      // const data = res.data.data;
      // const label = data.map((obj) => obj.label);
      // const target = data.map((obj) => obj.target);
      // const value = data.map((obj) => obj.value);
      if (!this.isActiveMonth) {
        this.chartOptions = {
          xaxis: {
            categories: [
              "Januari",
              "Februari",
              "Maret",
              "April",
              "Mei",
              "Juni",
              "Juli",
              "Agustus",
              "September",
              "Oktober",
              "November",
              "Desember",
            ],
          },
        };
        const datas = [
          {
            color: "#ff5151",
            name: "Target",
            type: "line",
            // data: target,
            data: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
          },
          {
            // color:"#8099D9",
            name: "Actual",
            type: "column",
            // data: value,
            data: [3, 2, 1, 3, 4, 5, 2, 0, 0, 0, 0, 0],
          },
        ];
        this.series = datas;
      } else {
        const datas = [
          {
            color: "#ff5151",
            name: "Target",
            type: "line",
            // data: target,
            data: [4, 4, 4, 4, 4, 4],
          },
          {
            // color:"#8099D9",
            name: "Actual",
            type: "column",
            // data: value,
            data: [3, 2, 1, 3, 4, 5],
          },
        ];
        this.chartOptions = {
          xaxis: {
            categories: ["2019", "2020", "2021", "2022", "2023", "2024"],
          },
        };
        this.series = datas;
      }
    },
    closeModal() {
      this.$emit("closeModal", false);
    },
  },

  watch: {
    async showModal() {
      if (this.showModal) {
        this.getDataCard();
        // this.getDataChart();
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom_header {
  padding: 1rem 1rem 0rem 1rem;
  border-bottom: unset;

  .custom_header_content {
    width: 100%;
    position: relative;

    .close_btn {
      position: absolute;
      right: 0;
      z-index: 999;
    }

    .tahun_text {
      font-size: 20px;
      font-weight: 400;
      line-height: 23px;
    }

    .judul_text {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
    }
  }
}

.custom-modal-width {
  max-width: 564px;
  width: 100%;
}

.tabs {
  color: #838383;
  font-size: 14px;
  padding: 5px;
  cursor: pointer;
}

.tabs_active {
  color: #00a3e9;
  border-bottom: 3px solid #00a3e9;
}

.custom_pb {
  background: unset !important;
  height: 8px;
}
.border-period-left {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.border-period-right {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.color-active {
  color: #fff !important;
}
.btn-disable {
  color: #999999;
  background-color: #e9e9e9;
}
.btn-small {
  padding: 0.4rem 1rem;
  font-size: 11px;
}
.modal-dialog-scrollable .modal-content {
  max-height: 100% !important;
}
</style>
